(function(){
    'use strict'

    angular.module('app.core')
    .factory('CoreSrv', CoreSrv);

    //CoreSrv.$inject = ['$q', '$http', 'apiSettings'];

    function CoreSrv(){

        var api = {
            getDias: getDias,
            getAnnos: getAnnos,
            getMeses:getMeses,
            getPropiedadesEmpleado: getPropiedadesEmpleado,
            dynamicSort: dynamicSort,
            getPropiedadesPeriodo: getPropiedadesPeriodo,
            getPropiedadesAsociacion: getPropiedadesAsociacion,
            getTiposRubroPerfilAsiento: getTiposRubroPerfilAsiento
        };

        return api;

        function getDias()
        {
            return [
                1,2,3,4,5,6,7,8,9,10,
                11,12,13,14,15,16,17,18,19,20,
                21,22,23,24,25,26,27,28,29,30,31
            ];
        };

        function getAnnos()
        {
            return [
                2019,
                2020
            ];
        };

        function getMeses()
        {
            return [
                {id: 1, nombre: 'Enero'},
                {id: 2, nombre: 'Febrero'},
                {id: 3, nombre: 'Marzo'},
                {id: 4, nombre: 'Abril'},
                {id: 5, nombre: 'Mayo'},
                {id: 6, nombre: 'Junio'},
                {id: 7, nombre: 'Julio'},
                {id: 8, nombre: 'Agosto'},
                {id: 9, nombre: 'Septiembre'},
                {id: 10, nombre: 'Octubre'},
                {id: 11, nombre: 'Noviembre'},
                {id: 12, nombre: 'Diciembre'},
            ];
        };

        function getPropiedadesEmpleado(){
            
            return ['SalarioMensual', 
            'SalarioQuincenal', 
            'SalarioSemanal', 
            'SalarioDiario', 
            'SalarioXHora', 
            'MontoAhorroAsociacion',
            'MontoAhorroEscolar', 
            'MontoBonificacion',
            'MontoSalarioPromedio',
            'DiasLaborados',
            'SaldoAcumuladoVacaciones',
            'Esposa',
            'EsPensionado',
            'EmbargoSalario',
            'NumeroHijos',
            'EnAsociacionSolidarista',
            'MontoEmbargoSalario',
            'MontoEmbargoSalario2',
            'MontoPensionAlimentaria',
            'EsOrdinario',
            'RebajoAlimentacion'].sort();

        }

        function getPropiedadesPeriodo(){
            return [
                'DiasCalendario',
                'PlanillasMes',
                'Nominas',
                'FactorDiasMes'
            ].sort();
        };

        function getPropiedadesAsociacion(){
            return [
                'PrestamosAsociacion',
                'AhorroVoluntario',
                'AhorroExtraordinario',
                'DeduccionesVarias',
                'ActividadesVarias',
                'AhorroObligatorio'
            ].sort();
        };

        function getTiposRubroPerfilAsiento()
        {
            return [
                {id: 1, nombre: 'Devengados'},
                {id: 2, nombre: 'Deducibles'},
                {id: 3, nombre: 'Otros Devengados'},
                {id: 4, nombre: 'Otros Deducibles'},
            ];
        };

        function dynamicSort(property) {
            var sortOrder = 1;
        
            if(property[0] === "-") {
                sortOrder = -1;
                property = property.substr(1);
            }
        
            return function (a,b) {
                if(sortOrder == -1){
                    return b[property].localeCompare(a[property]);
                }else{
                    return a[property].localeCompare(b[property]);
                }        
            }
        }

    };

})();